<template>
	<div>
		<!-- Validation Popup -->
		<vs-popup
			:active.sync="showValidationPopup"
			title="Validation de l'import"
			:not-close="loading"
		>
			<!-- Loading Overlay -->
			<div v-if="loading" class="loading-overlay">
				<div class="loading-content">
					<vs-loading type="circles" color="primary" size="large"></vs-loading>
					<p class="loading-text">Import en cours... Veuillez patienter</p>
					<p class="loading-subtext">Ne fermez pas cette fenêtre</p>
				</div>
			</div>

			<!-- Normal Content -->
			<div v-else>
				<div class="v-row">
					<p>
						Vous allez importer {{ netlinkTotal }} netlinks pour un total de
						{{ priceTotal }}€ pour {{ societyTotal }} clients, dont
						{{ noPurchaseNetlink.length }} netlinks sans achat pour un total de
						{{ noPurchaseNetlinkPriceTotal }}€.
					</p>
				</div>
				<div class="v-row">
					<vs-tabs>
						<vs-tab label="Importés">
							<vs-table :data="purchaseRecap" pagination :max-items="10">
								<template slot="thead">
									<vs-th>Nombre de netlinks</vs-th>
									<vs-th>Prix Total</vs-th>
									<vs-th>Prestataire</vs-th>
									<vs-th>Client</vs-th>
								</template>
								<template slot-scope="{ data }">
									<vs-tr v-for="(row, index) of data" :key="index">
										<vs-td>{{ row.netlink_total }}</vs-td>
										<vs-td>{{ row.price_total }}€</vs-td>
										<vs-td>{{ getProviderNameFromId(row.provider_id) }}</vs-td>
										<vs-td>{{ row.society_name }}</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</vs-tab>
					</vs-tabs>
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col">
					<vs-button
						color="danger"
						@click="showValidationPopup = false"
						:disabled="loading"
						>Annuler</vs-button
					>
				</div>
				<vs-spacer />
				<div class="vx-col">
					<vs-button
						color="primary"
						@click="acceptPurchases"
						:disabled="loading"
						:loading="loading"
					>
						<span v-if="!loading">Valider</span>
						<span v-else>Import en cours...</span>
					</vs-button>
				</div>
			</div>
		</vs-popup>

		<!-- Provider Popup -->
		<vs-popup
			:active.sync="showNewProviderPopup"
			title="Ajout des nouveaux prestataires"
		>
			<vs-table :data="newProviderList" v-model="selectedProviders">
				<template slot="thead">
					<vs-th
						><vs-checkbox
							v-model="allProviderSelected"
							@change="toggleAllProviders"
					/></vs-th>
					<vs-th>Nom du prestataire</vs-th>
					<vs-th>Prénom du contact</vs-th>
					<vs-th>Nom du contact</vs-th>
					<vs-th>Email</vs-th>
					<vs-th>Téléphone</vs-th>
					<vs-th>Valide</vs-th>
				</template>
				<template slot-scope="{ data }">
					<vs-tr v-for="(row, index) of data" :key="index">
						<vs-td><vs-checkbox v-model="row.selected" /></vs-td>
						<vs-td>{{ row.society }}</vs-td>
						<vs-td
							><vs-input
								v-model="row.firstname"
								@change="validateProvider(row)"
						/></vs-td>
						<vs-td
							><vs-input v-model="row.lastname" @change="validateProvider(row)"
						/></vs-td>
						<vs-td
							><vs-input v-model="row.email" @change="validateProvider(row)"
						/></vs-td>
						<vs-td
							><vs-input v-model="row.phone" @change="validateProvider(row)"
						/></vs-td>
						<vs-td>
							<vs-icon
								:icon="row.isValid ? 'check_circle' : 'feedback'"
								:color="row.isValid ? 'success' : 'danger'"
							/>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<div class="vx-row">
				<vs-button color="danger" @click="declineProviders">Annuler</vs-button>
				<vs-spacer />
				<vs-button color="primary" @click="acceptProviders">Valider</vs-button>
			</div>
		</vs-popup>

		<!-- File Input -->
		<input
			id="fileinput"
			type="file"
			accept=".csv,.xlsx"
			@change="handleFileUpload"
			style="display: none"
		/>

		<!-- Main Content -->
		<vx-card>
			<div class="vx-row w-full">
				<div class="vx-col">
					<vs-button color="primary" @click="setImportMode('v1')"
						>Ajouter Un Fichier Avec ID</vs-button
					>
				</div>
				<div class="vx-col">
					<vs-button color="success" @click="setImportMode('v2')"
						>Ajouter Un Fichier Avec Nom</vs-button
					>
				</div>
				<div class="vx-col">
					<vs-button color="primary" @click="downloadTemplate"
						>Télécharger le template</vs-button
					>
				</div>
				<vs-spacer />
				<!-- <div class="vx-col">
					<vs-button
						class="float-right"
						icon="icon-x"
						@click="$router.go(-1)"
					></vs-button>
				</div> -->
			</div>
		</vx-card>

		<vx-card class="mt-2" v-if="netlinkList.length > 0">
			<!-- Filters -->
			<div class="vx-row">
				<div class="vx-col pt-2">
					<span>Filtres : </span>
				</div>
				<div class="vx-col">
					<vs-input
						v-model="linkFilter"
						placeholder="Nom du lien"
						@input="linksFilter()"
					/>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="statusFilter"
						class="w-full select-large"
						placeholder="Statut (Sélection multiple)"
						multiple
						autocomplete
						@change="linksFilter()"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in netlinkStatus"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="typeFilter"
						class="w-full select-large"
						placeholder="Type de lien (Sélection multiple)"
						multiple
						autocomplete
						@change="linksFilter()"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item, index) in linkTypes"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="errorFilter"
						class="w-full select-large"
						placeholder="Niveau d'erreur (Sélection multiple)"
						multiple
						autocomplete
						@change="linksFilter()"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in errorOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
			</div>

			<!-- Results Summary -->
			<div class="vx-row mb-4">
				<strong
					>Total: {{ filteredNetlinks.length }} | Sélectionnés:
					{{ selectedCount }}</strong
				>
			</div>

			<!-- Netlinks Table -->
			<div class="vx-row w-full" style="overflow: auto">
				<vs-table
					:data="filteredNetlinks"
					pagination
					:max-items="25"
					class="w-full"
				>
					<template slot="thead">
						<vs-th
							><vs-checkbox v-model="allSelected" @change="toggleAllNetlinks"
						/></vs-th>
						<vs-th>Lien acheté</vs-th>
						<vs-th>Page de destination</vs-th>
						<vs-th>Contrat</vs-th>
						<vs-th>Prestation </vs-th>
						<vs-th>Prestataire</vs-th>
						<vs-th>Type ancre</vs-th>
						<vs-th>Ancre</vs-th>
						<vs-th>Type de lien</vs-th>
						<vs-th>Prix</vs-th>

						<vs-th>Statut</vs-th>
						<vs-th>Période</vs-th>
						<vs-th>Facturable</vs-th>
						<vs-th>Prix de vente</vs-th>
						<vs-th>Valide</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr
							v-for="(row, index) of data"
							:key="index"
							:style="getRowStyle(row.errorLevel)"
							:state="getRowState(row.errorLevel)"
						>
							<vs-td><vs-checkbox v-model="row.selected" /></vs-td>

							<vs-td>
								<vs-input
									v-model="row.url_bought"
									@change="onFieldChange(row, 'url_bought')"
									@blur="validateNetlink(row)"
								/>
							</vs-td>

							<vs-td>
								<vs-input
									v-model="row.landing_page"
									@change="onFieldChange(row, 'landing_page')"
									@blur="validateNetlink(row)"
								/>
							</vs-td>
							<vs-td>
								<vs-input
									style="width: 100px"
									v-model="row.contract_id"
									@change="onFieldChange(row, 'contract_id')"
									@blur="validateNetlink(row)"
								/>
							</vs-td>

							<vs-td>
								<div style="width: 200px">
									<select
										v-model="row.mission_id"
										class="form-select"
										@change="validateNetlink(row)"
									>
										<option value="" disabled>
											Sélectionner une prestation
										</option>
										<option
											v-for="mission in getMissionsForContract(row.contract_id)"
											:key="mission.id"
											:value="mission.id"
										>
											{{ mission.name }}
										</option>
									</select>
								</div>
							</vs-td>

							<vs-td>
								<div style="width: 150px">
									<select
										v-model="row.provider_id"
										class="form-select"
										@change="validateNetlink(row)"
									>
										<option value="" disabled>
											Sélectionner un prestataire
										</option>
										<option
											v-for="provider in netlinkProviders"
											:key="provider.id"
											:value="provider.id"
										>
											{{ provider.society }}
										</option>
									</select>
								</div>
							</vs-td>

							<vs-td>
								<div style="width: 150px">
									<select
										v-model="row.anchor_type"
										class="form-select"
										@change="validateNetlink(row)"
									>
										<option
											v-for="type in anchorTypes"
											:key="type.value"
											:value="type.value"
										>
											{{ type.text }}
										</option>
									</select>
								</div>
							</vs-td>

							<vs-td>
								<vs-input v-model="row.anchor" @change="validateNetlink(row)" />
							</vs-td>

							<vs-td>
								<div style="width: 150px">
									<select
										v-model="row.link_type"
										class="form-select"
										@change="validateNetlink(row)"
									>
										<option
											v-for="type in linkTypes"
											:key="type.id"
											:value="type.id"
										>
											{{ type.name }}
										</option>
									</select>
								</div>
							</vs-td>

							<vs-td>
								<vs-input
									style="width: 100px"
									v-model="row.price"
									type="number"
									@change="onFieldChange(row, 'price')"
									@blur="validateNetlink(row)"
								/>
							</vs-td>

							<vs-td>
								<div style="width: 150px">
									<select
										v-model="row.status"
										class="form-select"
										@change="validateNetlink(row)"
									>
										<option
											v-for="status in netlinkStatus"
											:key="status.value"
											:value="status.value"
										>
											{{ status.text }}
										</option>
									</select>
								</div>
							</vs-td>

							<vs-td>
								<flat-pickr
									v-model="row.period_date"
									:config="dateConfig"
									@on-change="onFieldChange(row, 'period_date')"
									@input="onFieldChange(row, ' period_date')"
									@on-close="onFieldChange(row, 'period_date')"
								/>
							</vs-td>

							<vs-td>
								<select
									v-model="row.is_billable"
									class="form-select"
									@change="validateNetlink(row)"
								>
									<option :value="0">Non</option>
									<option :value="1">Oui</option>
								</select>
							</vs-td>

							<vs-td>
								<vs-input
									style="width: 100px"
									v-model="row.sell_price"
									type="number"
									@change="validateNetlink(row)"
								/>
							</vs-td>

							<vs-td>
								<div
									class="validation-icon-container"
									@mouseenter="showTooltip($event, getErrorTooltipText(row))"
									@mouseleave="hideTooltip"
								>
									<vs-icon
										size="medium"
										:icon="getValidationIcon(row.errorLevel)"
										:color="getValidationColor(row.errorLevel)"
										class="validation-icon"
									/>
								</div>
							</vs-td>
						</vs-tr>

						<vs-tr v-if="data.length > 0">
							<vs-td colspan="15" class="text-center">
								<vs-button
									color="primary"
									@click="submitNetlinks"
									:disabled="loading"
								>
									Enregistrer les netlinks
								</vs-button>
							</vs-td>
						</vs-tr>
						<div
							v-if="tooltip.visible"
							class="custom-tooltip"
							:style="tooltip.style"
							ref="tooltipElement"
						>
							<div
								class="custom-tooltip-content"
								v-html="tooltip.text.replace(/\n/g, '<br>')"
							></div>
							<div class="custom-tooltip-arrow" :class="tooltip.position"></div>
						</div>
					</template>
				</vs-table>
			</div>
		</vx-card>

		<vx-card v-else>
			<h2>Veuillez importer un fichier. Téléchargez le template ci-dessus.</h2>
		</vx-card>
	</div>
</template>

<script>
import XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Netlink from "../../../entities/Netlink";
import moment from "moment";

export default {
	name: "ImportNetlinks",
	components: { flatPickr },

	data() {
		return {
			// Main data
			netlinkList: [],
			loading: false,
			importMode: "v1", // 'v1' for Résultats sheet, 'v2' for Données sheet

			// Popups
			showValidationPopup: false,
			showNewProviderPopup: false,

			// Providers
			newProviderList: [],
			allProviderSelected: false,
			selectedProviders: [],
			netlinkProviders: [],

			// Validation data
			purchaseRecap: [],
			netlinkTotal: 0,
			priceTotal: 0,
			societyTotal: 0,
			noPurchaseNetlink: [],
			noPurchaseNetlinkPriceTotal: 0,
			toUpdateNetlinks: [],
			renewNetlinks: [],

			// Filters
			linkFilter: "",
			statusFilter: [],
			typeFilter: [],
			errorFilter: [],

			// Selections
			allSelected: false,

			// Other data
			linkTypes: [],
			allMissions: [],
			contractsSocietiesWithName: [],

			// Constants
			netlinkStatus: [
				{ text: "Actif", value: 0 },
				{ text: "En attente", value: 1 },
				{ text: "Refusé", value: 2 },
				{ text: "Terminé", value: 3 },
				{ text: "En cours de rédaction", value: 4 },
				{ text: "Annulé", value: 5 },
			],

			anchorTypes: [
				{ text: "Brand et Générique", value: 0 },
				{ text: "Semi optimisée", value: 1 },
				{ text: "Générique", value: 2 },
				{ text: "Non optimisée", value: 3 },
				{ text: "Optimisée", value: 4 },
			],

			errorOptions: [
				{ text: "Valide", value: 0 },
				{ text: "Erreur", value: 1 },
				{ text: "Danger", value: 2 },
			],

			// Config
			dateConfig: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				dateFormat: "m/Y",
			},

			tooltip: {
				visible: false,
				text: "",
				style: {},
				position: "tooltip-top",
			},
		};
	},

	computed: {
		activeUser() {
			return this.$cookies.get("userInfo");
		},

		filteredNetlinks() {
			return this.netlinkList.filter((netlink) => {
				if (this.linkFilter) {
					let hasUrlMatch =
						netlink.url_bought && netlink.url_bought.includes(this.linkFilter);
					let hasLandingMatch =
						netlink.landing_page &&
						netlink.landing_page.includes(this.linkFilter);
					if (!hasUrlMatch && !hasLandingMatch) return false;
				}
				if (
					this.statusFilter.length &&
					!this.statusFilter.includes(netlink.status)
				)
					return false;
				if (
					this.typeFilter.length &&
					!this.typeFilter.includes(netlink.link_type)
				)
					return false;
				if (
					this.errorFilter.length &&
					!this.errorFilter.includes(netlink.errorLevel)
				)
					return false;
				return true;
			});
		},

		existingNetlinks() {
			return this.$store.state.netlink || [];
		},

		selectedCount() {
			return this.netlinkList.filter((nl) => nl.selected).length;
		},
	},

	async created() {
		// Initialize debounced validation
		this.initDebouncedValidation();
		await this.loadInitialData();
	},

	methods: {
		showTooltip(event, text) {
			this.tooltip.text = text;
			this.tooltip.visible = true;

			this.$nextTick(() => {
				this.positionTooltip(event);
			});
		},

		hideTooltip() {
			this.tooltip.visible = false;
		},

		positionTooltip(event) {
			if (!this.$refs.tooltipElement) return;

			const tooltip = this.$refs.tooltipElement;
			const trigger = event.currentTarget;
			const triggerRect = trigger.getBoundingClientRect();
			const tooltipRect = tooltip.getBoundingClientRect();
			const viewport = {
				width: window.innerWidth,
				height: window.innerHeight,
				scrollX: window.pageXOffset,
				scrollY: window.pageYOffset,
			};

			let position = "top";
			let left =
				triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
			let top = triggerRect.top - tooltipRect.height - 10;

			// Adjust if tooltip goes off left edge
			if (left < 10) {
				left = 10;
			}
			// Adjust if tooltip goes off right edge
			if (left + tooltipRect.width > viewport.width - 10) {
				left = viewport.width - tooltipRect.width - 10;
			}

			// If tooltip would go above viewport, show below instead
			if (top < 10) {
				position = "bottom";
				top = triggerRect.bottom + 10;
			}

			// If tooltip would go below viewport, try to show above
			if (top + tooltipRect.height > viewport.height - 10) {
				position = "top";
				top = triggerRect.top - tooltipRect.height - 10;
			}

			this.tooltip.position = `tooltip-${position}`;
			this.tooltip.style = {
				position: "fixed",
				left: `${left}px`,
				top: `${top}px`,
				zIndex: 9999,
			};
		},
		// Initialization
		async loadInitialData() {
			try {
				await Promise.all([
					this.$store.dispatch("getAllNetlink"),
					this.$store.dispatch("getAllNetlinkTypes"),
					this.$store.dispatch("getAllServices"),
					this.$store.dispatch("getAllProviders"),
					this.loadContractsSocietiesWithName(),
					this.loadMissions(),
				]);

				console.log("Store state after loading:", this.$store.state);
				console.log("Existing netlinks:", this.existingNetlinks);

				const netlinkTypes = this.$store.state.netlink_types || [];
				this.linkTypes = netlinkTypes.filter((t) => t.is_dns == 0);
				this.createProviderList();
			} catch (error) {
				console.error("Failed to load initial data:", error);
			}
		},

		async loadContractsSocietiesWithName() {
			try {
				const res = await this.$http.get(
					this.$store.state.backendApiUrl + "contract/getscn"
				);
				this.contractsSocietiesWithName = res.data;
			} catch (error) {
				console.error("Failed to load contracts:", error);
			}
		},

		async loadMissions() {
			try {
				const res = await this.$http.get(
					this.$store.state.backendApiUrl + "mission/all"
				);
				this.allMissions = res.data;
			} catch (error) {
				console.error("Failed to load missions:", error);
			}
		},

		createProviderList() {
			const services = this.$store.state.services || [];
			const netlinkService = services.find((s) => s.name === "Netlinking");
			if (!netlinkService) return;

			const providers = this.$store.state.providers || [];
			this.netlinkProviders = providers.filter((provider) => {
				const serviceList = provider.service_id_list
					? provider.service_id_list.split(",")
					: [];
				return serviceList.includes(netlinkService.id.toString());
			});
		},

		// File handling
		setImportMode(mode) {
			this.importMode = mode;
			console.log(`Import mode set to: ${mode}`);
			this.$vs.notify({
				title: "Mode sélectionné",
				text:
					mode === "v1"
						? "Import depuis feuille Résultats"
						: "Import V2 depuis feuille Données",
				color: "primary",
			});
			this.triggerFileUpload();
		},

		triggerFileUpload() {
			document.getElementById("fileinput").click();
		},

		async handleFileUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			this.loading = true;
			try {
				const workbook = await this.readFile(file);
				const netlinks = this.processWorkbook(workbook);
				this.addNetlinks(netlinks);
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors du traitement du fichier",
				});
				console.error(error);
			} finally {
				this.loading = false;
			}
		},

		readFile(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						const data = new Uint8Array(e.target.result);
						const workbook = XLSX.read(data, { type: "array" });
						resolve(workbook);
					} catch (error) {
						reject(error);
					}
				};
				reader.readAsArrayBuffer(file);
			});
		},

		processWorkbook(workbook) {
			// Process providers
			const providers = XLSX.utils.sheet_to_json(
				workbook.Sheets["Prestataires"],
				{ raw: true, defval: null }
			);
			this.processProviders(providers);

			// Process netlinks based on import mode
			if (this.importMode === "v2") {
				return this.processWorkbookV2(workbook);
			} else {
				return this.processWorkbookV1(workbook);
			}
		},

		processWorkbookV1(workbook) {
			// Original processing from Résultats tab
			const data = XLSX.utils.sheet_to_json(workbook.Sheets["Résultats"], {
				raw: false,
				defval: null,
			});
			console.log("V1 Import - Raw netlink data from Résultats sheet:", data);

			let processedData = data
				.filter((row) => row["url_bought"]) // Exclude rows with null/undefined/empty url_bought
				.map((row) => {
					return {
						url_bought: row["url_bought"],
						landing_page: row["landing_page"] || row["destination_link"],
						contract_id: parseInt(row["contract_id"]),
						mission_id: parseInt(row["mission_id"]),
						provider_id: parseInt(row["provider_id"]),
						price: this.parsePrice(row["price"]),
						sell_price: this.parsePrice(row["sell_price"]),
						status: parseInt(row["status"]) || 0,
						anchor_type: parseInt(row["anchor_type"]) || 0,
						anchor: row["anchor"],
						link_type: parseInt(row["link_type"]) || 1,
						renew_duration: parseInt(row["renew_duration"]),
						is_international: parseInt(row["is_international"]),
						period_date: this.formatPeriodDate(row["period_date"]),
						is_billable: parseInt(row["is_billable"]),
						selected: true,
						errorLevel: 0,
						isDuplicate: false,
						errors: [],
					};
				});

			return processedData;
		},

		processWorkbookV2(workbook) {
			// New processing from Données tab with name matching
			const data = XLSX.utils.sheet_to_json(workbook.Sheets["Données"], {
				raw: false,
				defval: null,
			});
			console.log(
				`V2 Import - Processing ${data.length} rows from Données sheet`
			);

			let processedData = data
				.filter((row) => row["Lien acheté"]) // Exclude rows with null/undefined/empty url_bought
				.map((row, index) => {
					// Get mission_id by matching prestation name or extracting ID
					let missionId = null;
					const prestationName = row["Prestation"];
					const contractId = row["N° de contrat"];

					console.log(
						`Processing Prestation: "${prestationName}" for Contract: "${contractId}"`
					);

					if (prestationName && contractId) {
						// First try to extract mission ID directly from the format "58 - mission name"
						const idMatch = prestationName.match(/^(\d+)\s*-/);
						if (idMatch) {
							const extractedId = parseInt(idMatch[1]);
							console.log(`Extracted ID from prestation: ${extractedId}`);

							// Verify this mission exists for the contract
							const verifyMission = this.allMissions.find(
								(m) => m.id === extractedId && m.contract_id == contractId
							);
							if (verifyMission) {
								missionId = extractedId;
								console.log(
									`✅ Verified mission ID ${missionId} exists for contract ${contractId}`
								);
							} else {
								console.warn(
									`❌ Mission ID ${extractedId} not found for contract ${contractId}`
								);
								console.log(
									"Available missions for this contract:",
									this.allMissions
										.filter((m) => m.contract_id == contractId)
										.map((m) => ({ id: m.id, name: m.perform }))
								);
							}
						}

						// If ID extraction didn't work, try matching by name
						if (!missionId) {
							const nameWithoutId = prestationName.replace(/^\d+\s*-\s*/, "");
							console.log(`Trying to match by name: "${nameWithoutId}"`);

							const matchingMission = this.allMissions.find(
								(m) =>
									m.contract_id == contractId &&
									(m.perform === nameWithoutId ||
										(m.commentary &&
											`${m.perform}: ${m.commentary}` === nameWithoutId) ||
										m.commentary === nameWithoutId)
							);
							if (matchingMission) {
								missionId = matchingMission.id;
								console.log(
									`✅ Matched prestation "${prestationName}" to mission ID: ${missionId}`
								);
							} else {
								console.warn(
									`❌ No matching mission found for prestation: "${prestationName}" in contract ${contractId}`
								);
							}
						}
					} else {
						console.warn(
							`Missing data - Prestation: "${prestationName}", Contract: "${contractId}"`
						);
					}

					// Get provider_id by matching provider name
					let providerId = null;
					const providerName = row["Prestataire"];
					if (providerName) {
						const matchingProvider = this.netlinkProviders.find(
							(p) => p.society === providerName
						);
						if (matchingProvider) {
							providerId = matchingProvider.id;
						} else {
							// Try to find in the global providers list
							const globalProvider = (this.$store.state.providers || []).find(
								(p) => p.society === providerName
							);
							if (globalProvider) {
								providerId = globalProvider.id;
							}
						}
					}

					// Map status text to status code
					let statusCode = 0;
					const statusText = row["Statut"];
					if (statusText) {
						const statusMap = {
							Actif: 0,
							"En attente": 1,
							Refusé: 2,
							Terminé: 3,
							"En cours de rédaction": 4,
							Annulé: 5,
						};
						statusCode =
							statusMap[statusText] !== undefined ? statusMap[statusText] : 0;
					}

					// Map anchor type text to code
					let anchorTypeCode = 0;
					const anchorTypeText = row["Type d'ancre"];
					if (anchorTypeText) {
						const anchorTypeMap = {
							"Brand et Générique": 0,
							"Semi optimisée": 1,
							Générique: 2,
							"Non optimisée": 3,
							Optimisée: 4,
						};
						anchorTypeCode =
							anchorTypeMap[anchorTypeText] !== undefined
								? anchorTypeMap[anchorTypeText]
								: 0;
					}

					// Map link type text to ID
					let linkTypeId = 1;
					const linkTypeText = row["Type de lien"];
					if (linkTypeText && this.linkTypes) {
						const matchingLinkType = this.linkTypes.find(
							(lt) => lt.name === linkTypeText
						);
						if (matchingLinkType) {
							linkTypeId = matchingLinkType.id;
						}
					}

					// Map renewal duration
					let renewDuration = 0;
					const renewText = row["Renouvellement"];
					if (renewText) {
						if (renewText.toLowerCase().includes("vie")) {
							renewDuration = 0;
						} else if (renewText.toLowerCase().includes("mois")) {
							renewDuration = 1;
						} else if (renewText.toLowerCase().includes("an")) {
							renewDuration = 12;
						}
					}

					// Map billable
					let isBillable = 1;
					const billableText = row["Facturable"];
					if (billableText) {
						isBillable =
							billableText.toLowerCase() === "oui" || billableText === "1"
								? 1
								: 0;
					}

					// Check if international
					let isInternational = 0;
					const internationalText = row["Internationale"];
					if (internationalText) {
						isInternational =
							internationalText.toLowerCase() === "oui" ||
							internationalText === "1"
								? 1
								: 0;
					}

					return {
						url_bought: row["Lien acheté"],
						landing_page: row["Lien de destination"],
						contract_id: parseInt(contractId) || null,
						mission_id: missionId,
						provider_id: providerId,
						price: this.parsePrice(row["Prix d'Achats (HT)"]),
						sell_price: this.parsePrice(row["Prix de Vente (HT)"]),
						status: statusCode,
						anchor_type: anchorTypeCode,
						anchor: row["Ancre"],
						link_type: linkTypeId,
						renew_duration: renewDuration,
						is_international: isInternational,
						period_date: this.formatPeriodDateV2(row["Période"]),
						is_billable: isBillable,
						selected: true,
						errorLevel: 0,
						isDuplicate: false,
						errors: [],
					};
				});

			return processedData;
		},

		processProviders(providers) {
			const existingProviders = this.$store.state.providers || [];
			this.newProviderList = providers
				.filter((p) => !p["ID"])
				.filter((p) => {
					// Check if provider already exists
					for (let i = 0; i < existingProviders.length; i++) {
						if (existingProviders[i].society === p["Nom du Prestataire"]) {
							return false;
						}
					}
					return true;
				})
				.map((p) => {
					const phone = p["Téléphone du contact (optionnel)"];
					return {
						society: p["Nom du Prestataire"],
						firstname: p["Prénom du contact principal"],
						lastname: p["Nom du contact du principal"],
						email: p["Adresse mail du contact"],
						phone: phone ? phone.toString() : null,
						selected: true,
						isValid: false,
					};
				});

			if (this.newProviderList.length > 0) {
				this.showNewProviderPopup = true;
			}
		},

		// Simple duplicate checking
		checkForDuplicateUrls(newNetlinks) {
			console.log("Checking for duplicates...");
			console.log("Existing netlinks:", this.existingNetlinks);

			if (!this.existingNetlinks || this.existingNetlinks.length === 0) {
				console.warn("No existing netlinks found in store");
				newNetlinks.forEach((netlink) => {
					netlink.isDuplicate = false;
				});
				return newNetlinks;
			}

			// Create a set of existing URL combinations for faster lookup
			const existingCombinations = new Set();

			this.existingNetlinks.forEach((nl) => {
				if (nl && nl.url_bought && nl.landing_page) {
					const urlCombo = `${nl.url_bought
						.toLowerCase()
						.trim()}-${nl.landing_page.toLowerCase().trim()}`;
					existingCombinations.add(urlCombo);
				}
			});

			console.log("Existing URL combinations:", existingCombinations);

			// Check each new netlink against existing ones
			newNetlinks.forEach((netlink, index) => {
				if (!netlink.url_bought || !netlink.landing_page) {
					netlink.isDuplicate = false;
					return;
				}

				const newCombo = `${netlink.url_bought
					.toLowerCase()
					.trim()}-${netlink.landing_page.toLowerCase().trim()}`;

				if (existingCombinations.has(newCombo)) {
					// Mark as duplicate
					netlink.isDuplicate = true;

					// Add to errors array if it exists
					if (!netlink.errors) netlink.errors = [];
					if (
						!netlink.errors.includes("URL déjà existante en base de données")
					) {
						netlink.errors.push("URL déjà existante en base de données");
					}

					console.log(
						`Database duplicate found: ${netlink.url_bought} -> ${netlink.landing_page}`
					);
				} else {
					netlink.isDuplicate = false;
				}

				// Also check for duplicates within the current import batch
				const duplicatesInBatch = newNetlinks.filter(
					(nl, i) =>
						i !== index &&
						nl.url_bought &&
						nl.landing_page &&
						`${nl.url_bought.toLowerCase().trim()}-${nl.landing_page
							.toLowerCase()
							.trim()}` === newCombo
				);

				if (duplicatesInBatch.length > 0) {
					netlink.isDuplicate = true;

					if (!netlink.errors) netlink.errors = [];
					if (!netlink.errors.includes("Doublon dans le fichier importé")) {
						netlink.errors.push("Doublon dans le fichier importé");
					}

					console.log(
						`File duplicate found: ${netlink.url_bought} -> ${netlink.landing_page}`
					);
				}
			});

			console.log("Netlinks after duplicate checking:", newNetlinks);
			return newNetlinks;
		},

		addNetlinks(netlinks) {
			// Filter and sort netlinks
			const validNetlinks = netlinks
				.filter((nl) => nl.url_bought && nl.landing_page)
				.sort((a, b) => {
					const keyA = a.url_bought + a.landing_page;
					const keyB = b.url_bought + b.landing_page;
					return keyA.localeCompare(keyB);
				});

			// Remove duplicates within the upload
			let uniqueNetlinks = validNetlinks.filter((item, pos, ary) => {
				return (
					!pos ||
					item.url_bought + item.landing_page !==
						ary[pos - 1].url_bought + ary[pos - 1].landing_page
				);
			});

			// Check against database duplicates
			uniqueNetlinks = this.checkForDuplicateUrls(uniqueNetlinks);

			console.log(
				"Unique netlinks after checking for duplicates:",
				uniqueNetlinks
			);

			// Validate and sort by error level
			uniqueNetlinks.forEach((nl) => this.validateNetlink(nl));

			this.netlinkList = uniqueNetlinks.sort(
				(a, b) => b.errorLevel - a.errorLevel
			);
		},

		// Enhanced validation that properly updates state
		// Enhanced validation that properly updates state
		// Enhanced validation - Duplicates are ALWAYS warnings, never critical errors
		// Enhanced validation - Duplicates are ALWAYS warnings, never critical errors
		validateNetlink(netlink) {
			// Clear previous errors and reset state
			netlink.errors = [];
			netlink.isDuplicate = false;
			netlink.oldNetlinkId = null;

			console.log("Validating netlink:", netlink);

			const validationErrors = []; // CRITICAL errors only (missing fields, invalid data)
			const duplicateErrors = []; // WARNING errors only (duplicates)

			// === CRITICAL VALIDATION ERRORS (RED) ===
			// URL validation
			if (!this.isValidUrl(netlink.url_bought)) {
				validationErrors.push("URL source invalide");
			}
			if (!this.isValidUrl(netlink.landing_page)) {
				validationErrors.push("URL destination invalide");
			}

			// Required fields
			if (!netlink.contract_id) validationErrors.push("Contrat requis");
			if (!netlink.mission_id) validationErrors.push("Prestation requise");
			if (!netlink.provider_id) validationErrors.push("Prestataire requis");

			// Link type validation - NEW VALIDATION
			if (!netlink.link_type) {
				validationErrors.push("Type de lien requis");
			} else if (this.linkTypes && this.linkTypes.length > 0) {
				// Only validate if linkTypes is loaded, and check if the link_type ID exists
				const linkTypeExists = this.linkTypes.some(
					(linkType) => linkType.id == netlink.link_type
				);
				if (!linkTypeExists) {
					validationErrors.push("Type de lien invalide");
				}
			}

			// Price validation
			if (
				(!netlink.price || isNaN(netlink.price)) &&
				(!netlink.sell_price || isNaN(netlink.sell_price))
			) {
				validationErrors.push("Prix invalide");
			}

			// Billable validation
			if (netlink.is_billable === 2) {
				if (!netlink.sell_price || netlink.sell_price <= 0) {
					validationErrors.push("Prix de vente requis pour facturable");
				}
			}

			// === DUPLICATE CHECKING (YELLOW WARNING) ===
			// Check for duplicates - these are ALWAYS warnings, never critical errors
			if (
				netlink.url_bought &&
				netlink.landing_page &&
				netlink.contract_id &&
				netlink.period_date
			) {
				this.checkSingleNetlinkForDuplicates(netlink);

				// All duplicate-related errors go to duplicateErrors array
				if (netlink.errors && netlink.errors.length > 0) {
					netlink.errors.forEach((error) => {
						// These are all duplicate-related patterns
						if (
							error.includes("déjà existant") ||
							error.includes("Doublon") ||
							error.includes("existant trouvé") ||
							error.includes("liste d'import")
						) {
							duplicateErrors.push(error);
						} else {
							// If somehow a non-duplicate error was added, treat as validation error
							validationErrors.push(error);
						}
					});
				}
			}

			// === COMBINE ALL ERRORS FOR DISPLAY ===
			netlink.errors = [...validationErrors, ...duplicateErrors];

			// === SET ERROR LEVEL ===
			if (validationErrors.length > 0) {
				// CRITICAL ERRORS (RED) - Data validation issues (takes priority even if duplicates exist)
				netlink.errorLevel = 1;
				if (duplicateErrors.length > 0) {
					netlink.isDuplicate = true;
					console.log(
						`❌ Critical validation errors + ⚠️ Duplicate warnings:`,
						{
							validationErrors,
							duplicateErrors,
						}
					);
				} else {
					console.log(`❌ Critical validation errors:`, validationErrors);
				}
			} else if (duplicateErrors.length > 0) {
				// WARNING LEVEL (YELLOW) - Duplicates only
				netlink.errorLevel = 2;
				netlink.isDuplicate = true;
				console.log(`⚠️ Duplicate warnings:`, duplicateErrors);
			} else {
				// NO ERRORS (GREEN) - Valid
				netlink.errorLevel = 0;
				console.log(`✅ Valid netlink`);
			}

			// Set period date if invalid
			if (!netlink.period_date || !this.isValidPeriod(netlink.period_date)) {
				const now = new Date();
				netlink.period_date = now.getMonth() + 1 + "/" + now.getFullYear();
			}

			console.log(`📊 Final validation result:`, {
				errorLevel: netlink.errorLevel,
				errorLevelText: ["VALID", "CRITICAL ERROR", "WARNING"][
					netlink.errorLevel
				],
				validationErrors: validationErrors.length,
				duplicateErrors: duplicateErrors.length,
				isDuplicate: netlink.isDuplicate,
				hasBothErrorTypes:
					validationErrors.length > 0 && duplicateErrors.length > 0,
			});

			// Force reactivity update
			this.$forceUpdate();
		},
		// Extract domain from URL for duplicate detection
		extractDomain(url) {
			if (!url || typeof url !== "string") {
				return null;
			}

			try {
				let cleanUrl = url.trim();

				// Add protocol if missing
				if (
					!cleanUrl.startsWith("http://") &&
					!cleanUrl.startsWith("https://")
				) {
					cleanUrl = `http://${cleanUrl}`;
				}

				const urlObj = new URL(cleanUrl);
				let domain = urlObj.hostname;

				// Remove www prefix
				if (domain.startsWith("www.")) {
					domain = domain.substring(4);
				}

				return domain.toLowerCase();
			} catch (error) {
				// If URL parsing fails, try to extract domain manually
				let domain = url
					.trim()
					.replace(/^https?:\/\//, "")
					.replace(/^www\./, "")
					.split("/")[0]
					.split("?")[0]
					.split("#")[0]
					.toLowerCase();

				return domain || null;
			}
		},

		// Normalize period format to MM/YYYY
		normalizePeriod(period) {
			if (!period || typeof period !== "string") {
				return null;
			}

			const cleaned = period.trim();

			// Already in MM/YYYY format
			if (/^\d{1,2}\/\d{4}$/.test(cleaned)) {
				const [month, year] = cleaned.split("/");
				return `${month.padStart(2, "0")}/${year}`;
			}

			// Handle other formats if needed
			// Add more format handling here if required

			return cleaned;
		},

		// Advanced duplicate checking with update/insert logic
		checkSingleNetlinkForDuplicates(netlink) {
			// Clear any existing duplicate state
			netlink.oldNetlinkId = null;
			netlink.isDuplicate = false;

			if (
				!netlink.url_bought ||
				!netlink.landing_page ||
				!netlink.contract_id ||
				!netlink.period_date
			) {
				return;
			}

			// Extract primary identification criteria (ONLY these matter for duplicates)
			const currentDomain = this.extractDomain(netlink.url_bought);
			const currentPeriod = this.normalizePeriod(netlink.period_date);
			const currentContract = netlink.contract_id.toString();

			if (!currentDomain || !currentPeriod) {
				return;
			}

			console.log(`🔍 Checking for duplicates:`, {
				domain: currentDomain,
				period: currentPeriod,
				contract: currentContract,
				anchor: netlink.anchor,
				landing_page: netlink.landing_page,
			});

			// Check against existing database netlinks
			let matchingNetlink = null;
			if (this.existingNetlinks && this.existingNetlinks.length > 0) {
				matchingNetlink = this.existingNetlinks.find((nl) => {
					if (!nl || !nl.url_bought || !nl.period_date || !nl.contract_id) {
						return false;
					}

					const existingDomain = this.extractDomain(nl.url_bought);
					const existingPeriod = this.normalizePeriod(nl.period_date);
					const existingContract = nl.contract_id.toString();

					// ONLY domain + period + contract determine if it's a duplicate
					const isDuplicate =
						existingDomain === currentDomain &&
						existingPeriod === currentPeriod &&
						existingContract === currentContract;

					if (isDuplicate) {
						console.log(`✅ Database duplicate found:`, {
							existing: {
								domain: existingDomain,
								period: existingPeriod,
								contract: existingContract,
								anchor: nl.anchor,
								landing_page: nl.landing_page,
							},
							current: {
								domain: currentDomain,
								period: currentPeriod,
								contract: currentContract,
								anchor: netlink.anchor,
								landing_page: netlink.landing_page,
							},
						});

						// Log what kind of update this would be
						const landingMatch =
							nl.landing_page &&
							netlink.landing_page &&
							nl.landing_page.toLowerCase().trim() ===
								netlink.landing_page.toLowerCase().trim();
						const anchorMatch =
							nl.anchor &&
							netlink.anchor &&
							nl.anchor.toLowerCase().trim() ===
								netlink.anchor.toLowerCase().trim();
						const statusMatch = nl.status === netlink.status;

						console.log(`📝 Update details:`, {
							landingPageChanged: !landingMatch,
							anchorChanged: !anchorMatch,
							statusChanged: !statusMatch,
							isExactDuplicate: landingMatch && anchorMatch && statusMatch,
						});
					}

					return isDuplicate;
				});

				if (matchingNetlink) {
					// This is a duplicate regardless of secondary field differences
					netlink.oldNetlinkId = matchingNetlink.id;
					netlink.isDuplicate = true;

					if (!netlink.errors) netlink.errors = [];

					// Determine the type of duplicate for user information
					const landingMatch =
						matchingNetlink.landing_page &&
						netlink.landing_page &&
						matchingNetlink.landing_page.toLowerCase().trim() ===
							netlink.landing_page.toLowerCase().trim();
					const anchorMatch =
						matchingNetlink.anchor &&
						netlink.anchor &&
						matchingNetlink.anchor.toLowerCase().trim() ===
							netlink.anchor.toLowerCase().trim();
					const statusMatch = matchingNetlink.status === netlink.status;

					if (landingMatch && anchorMatch && statusMatch) {
						netlink.errors.push(
							"Netlink identique déjà existant (même domaine/période/contrat)"
						);
					} else {
						// List what's different
						const differences = [];
						if (!landingMatch) differences.push("page de destination");
						if (!anchorMatch) differences.push("ancre");
						if (!statusMatch) differences.push("statut");

						netlink.errors.push(
							`Netlink existant trouvé (même domaine/période/contrat) - Différences: ${differences.join(
								", "
							)}`
						);
					}

					console.log(
						`🔄 Duplicate case: oldNetlinkId = ${netlink.oldNetlinkId}`
					);
				} else {
					console.log(`✨ New netlink case: no database match found`);
				}
			}

			// Check against other netlinks in current import list
			const duplicatesInList = this.netlinkList.filter((nl) => {
				if (
					nl === netlink ||
					!nl.url_bought ||
					!nl.landing_page ||
					!nl.contract_id ||
					!nl.period_date
				) {
					return false;
				}

				const otherDomain = this.extractDomain(nl.url_bought);
				const otherPeriod = this.normalizePeriod(nl.period_date);
				const otherContract = nl.contract_id.toString();

				// Same logic: only domain + period + contract matter
				const isListDuplicate =
					otherDomain === currentDomain &&
					otherPeriod === currentPeriod &&
					otherContract === currentContract;

				if (isListDuplicate) {
					console.log(`🔄 List duplicate found:`, {
						other: {
							domain: otherDomain,
							period: otherPeriod,
							contract: otherContract,
						},
						current: {
							domain: currentDomain,
							period: currentPeriod,
							contract: currentContract,
						},
					});
				}

				return isListDuplicate;
			});

			if (duplicatesInList.length > 0) {
				netlink.isDuplicate = true;
				if (!netlink.errors) netlink.errors = [];
				netlink.errors.push(
					"Doublon dans la liste d'import (même domaine/période/contrat)"
				);
			}

			// Final debug log
			console.log(`🎯 Final duplicate status:`, {
				isDuplicate: netlink.isDuplicate,
				oldNetlinkId: netlink.oldNetlinkId,
				errors: netlink.errors,
				domain: currentDomain,
				period: currentPeriod,
				contract: currentContract,
			});
		},

		// Get tooltip text for validation errors
		getErrorTooltipText(row) {
			if (!row.errors || row.errors.length === 0) {
				if (row.errorLevel === 0) {
					return "✅ Netlink valide - Prêt pour l'import";
				}
				return "Aucune erreur détectée";
			}

			let tooltipText = "";
			if (row.errorLevel === 1) {
				tooltipText = "❌ ERREURS:\n";
			} else if (row.errorLevel === 2) {
				tooltipText = "⚠️ Attention:\n";
			}

			// Group errors by type for better readability
			const criticalErrors = row.errors.filter(
				(error) =>
					!error.includes("déjà existante") && !error.includes("Doublon")
			);
			const duplicateErrors = row.errors.filter(
				(error) => error.includes("déjà existante") || error.includes("Doublon")
			);

			if (criticalErrors.length > 0) {
				tooltipText += "\n A corriger:\n";
				criticalErrors.forEach((error, index) => {
					tooltipText += `  ${index + 1}. ${error}\n`;
				});
			}

			if (duplicateErrors.length > 0) {
				tooltipText += "\n🟡 Avertissements de doublons:\n";
				duplicateErrors.forEach((error, index) => {
					tooltipText += `  ${index + 1}. ${error}\n`;
				});
			}

			if (row.errorLevel === 2 && duplicateErrors.length > 0) {
				tooltipText +=
					"\n💡 Les doublons peuvent être importés mais vérifiez s'il s'agit de mises à jour.";
			}

			return tooltipText.trim();
		},

		// Debounced validation for better UX
		debouncedValidateNetlink: null,

		// Initialize debounced function
		initDebouncedValidation() {
			this.debouncedValidateNetlink = this.debounce((netlink) => {
				this.validateNetlink(netlink);
			}, 500);
		},

		// Debounce utility function
		debounce(func, wait) {
			let timeout;
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout);
					func(...args);
				};
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		},

		// Enhanced validation trigger (can be used for real-time validation)
		onFieldChange(netlink, fieldName) {
			// Immediate validation for critical fields
			if (
				[
					"url_bought",
					"landing_page",
					"price",
					"contract_id",
					"period_date",
				].includes(fieldName)
			) {
				this.validateNetlink(netlink);
			} else {
				// Debounced validation for less critical fields
				if (this.debouncedValidateNetlink) {
					this.debouncedValidateNetlink(netlink);
				} else {
					this.validateNetlink(netlink);
				}
			}
		},

		validateProvider(provider) {
			const errors = [];

			if (!provider.firstname.trim()) errors.push("Prénom requis");
			if (!provider.lastname.trim()) errors.push("Nom requis");
			if (!provider.email.trim() || !this.isValidEmail(provider.email))
				errors.push("Email invalide");

			provider.isValid = errors.length === 0;
			provider.errors = errors;
		},

		isValidUrl(url) {
			if (!url || typeof url !== "string" || url.trim().length === 0) {
				return false;
			}

			try {
				// Clean the URL
				const cleanUrl = url.trim();
				if (
					cleanUrl.startsWith("http://") ||
					cleanUrl.startsWith("https://") ||
					cleanUrl.startsWith("wwww.")
				) {
					return true;
				} else return false;

				// // Check if it's a proper URL format with domain and TLD
				// const urlPattern =
				// 	/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;

				// if (!urlPattern.test(cleanUrl)) {
				// 	return false;
				// }

				// // Try to create URL object
				// let testUrl;
				// if (cleanUrl.startsWith("http://") || cleanUrl.startsWith("https://")) {
				// 	testUrl = new URL(cleanUrl);
				// } else {
				// 	testUrl = new URL(`http://${cleanUrl}`);
				// }

				// // Additional checks for valid hostname
				// const hostname = testUrl.hostname;

				// // Must have at least one dot (domain.tld)
				// if (!hostname.includes(".")) {
				// 	return false;
				// }

				// // Must not start or end with dot
				// if (hostname.startsWith(".") || hostname.endsWith(".")) {
				// 	return false;
				// }

				// // Must have valid TLD (at least 2 characters after last dot)
				// const parts = hostname.split(".");
				// const tld = parts[parts.length - 1];
				// if (tld.length < 2) {
				// 	return false;
				// }

				// // Check for valid characters in hostname
				// const hostnamePattern = /^[a-zA-Z0-9.-]+$/;
				// if (!hostnamePattern.test(hostname)) {
				// 	return false;
				// }

				// return true;
			} catch {
				return false;
			}
		},

		isValidEmail(email) {
			return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
		},

		isValidPeriod(period) {
			const parts = period.split("/");
			return (
				parts.length === 2 &&
				!isNaN(parts[0]) &&
				!isNaN(parts[1]) &&
				parts[0] >= 1 &&
				parts[0] <= 12 &&
				parts[1].length === 4
			);
		},

		// UI helpers
		getRowStyle(errorLevel) {
			const styles = [
				"background: rgba(40,199,111,.1) !important;",
				"background: rgba(234,84,85,.1) !important;",
				"background: rgba(255,245,198,.1) !important;",
			];
			return styles[errorLevel] || "";
		},

		getRowState(errorLevel) {
			return ["success", "danger", "warning"][errorLevel] || "";
		},

		getValidationIcon(errorLevel) {
			return ["check_circle", "error", "warning"][errorLevel] || "check_circle";
		},

		getValidationColor(errorLevel) {
			return ["success", "danger", "warning"][errorLevel] || "success";
		},

		// Filters and selections
		linksFilter() {
			// Original filter logic without duplicate-specific filters
			// Filters are applied via computed property filteredNetlinks
		},

		toggleAllNetlinks() {
			this.filteredNetlinks.forEach((nl) => (nl.selected = this.allSelected));
		},

		toggleAllProviders() {
			this.newProviderList.forEach(
				(p) => (p.selected = this.allProviderSelected)
			);
		},

		// Utilities
		getProviderNameFromId(id) {
			const provider = this.netlinkProviders.find((p) => p.id === id);
			return provider ? provider.society : "";
		},

		getSocietyNameFromContractId(contractId) {
			const contract = this.contractsSocietiesWithName.find(
				(c) => c.contract_id == contractId
			);
			return contract ? contract.society_name : "";
		},

		getMissionsForContract(contractId) {
			return this.allMissions
				.filter(
					(m) => m.contract_id == contractId && [7, 2].includes(m.sub_category)
				)
				.map((m) => ({
					id: m.id,
					name: m.commentary ? m.perform + ": " + m.commentary : m.perform,
				}));
		},

		// Actions
		// Updated submit logic - allow valid netlinks AND duplicates (warnings)
		async submitNetlinks() {
			// Allow both valid (0) and warning/duplicate (2) netlinks
			// Block only critical errors (1)
			const selectedNetlinks = this.netlinkList.filter(
				(nl) => nl.selected && (nl.errorLevel === 0 || nl.errorLevel === 2)
			);

			const criticalErrorNetlinks = this.netlinkList.filter(
				(nl) => nl.selected && nl.errorLevel === 1
			);

			if (selectedNetlinks.length === 0) {
				if (criticalErrorNetlinks.length > 0) {
					this.$vs.notify({
						title: "Erreur",
						text: `${criticalErrorNetlinks.length} netlink(s) avec des erreurs critiques sélectionnés. Corrigez les erreurs avant l'import.`,
						color: "danger",
					});
				} else {
					this.$vs.notify({
						title: "Erreur",
						text: "Aucun netlink valide sélectionné",
						color: "danger",
					});
				}
				return;
			}

			// Show info about what will be imported
			const validNetlinks = selectedNetlinks.filter(
				(nl) => nl.errorLevel === 0
			);
			const duplicateNetlinks = selectedNetlinks.filter(
				(nl) => nl.errorLevel === 2
			);

			console.log(`📊 Import summary:`, {
				total: selectedNetlinks.length,
				valid: validNetlinks.length,
				duplicates: duplicateNetlinks.length,
				blocked: criticalErrorNetlinks.length,
			});

			if (duplicateNetlinks.length > 0) {
				this.$vs.notify({
					title: "Information",
					text: `${duplicateNetlinks.length} doublons seront mis à jour, ${validNetlinks.length} nouveaux netlinks seront créés.`,
					color: "warning",
				});
			}

			// Prepare data for validation popup
			await this.prepareValidationData(selectedNetlinks);
			this.showValidationPopup = true;
		},

		async prepareValidationData(netlinks) {
			// Group by provider and contract for purchase recap
			const grouped = {};

			netlinks.forEach((nl) => {
				const key = nl.provider_id + "-" + nl.contract_id;
				if (!grouped[key]) {
					grouped[key] = {
						provider_id: nl.provider_id,
						society_name: this.getSocietyNameFromContractId(nl.contract_id),
						netlink_total: 0,
						price_total: 0,
						netlinks: [],
					};
				}
				grouped[key].netlink_total++;
				grouped[key].price_total += parseFloat(nl.price);
				grouped[key].netlinks.push(nl);
			});

			this.purchaseRecap = Object.values(grouped);
			this.netlinkTotal = netlinks.length;
			this.priceTotal = netlinks
				.reduce((sum, nl) => sum + parseFloat(nl.price), 0)
				.toFixed(2);
			this.societyTotal = new Set(netlinks.map((nl) => nl.contract_id)).size;
		},

		async acceptPurchases() {
			this.loading = true;
			try {
				// Submit purchases logic here
				await this.submitPurchasesToServer();

				this.showValidationPopup = false;
				this.$vs.notify({
					title: "Succès",
					text: "Netlinks importés avec succès",
				});

				// Remove submitted netlinks
				const submittedIds = this.netlinkList
					.filter((nl) => nl.selected)
					.map((_, i) => i);
				this.netlinkList = this.netlinkList.filter(
					(_, i) => !submittedIds.includes(i)
				);
			} catch (error) {
				this.$vs.notify({ title: "Erreur", text: "Erreur lors de l'import" });
				console.error(error);
			} finally {
				this.loading = false;
			}
		},

		// Fixed submitPurchasesToServer using your existing methods
		async submitPurchasesToServer() {
			const selectedNetlinks = this.netlinkList.filter((nl) => nl.selected);

			if (selectedNetlinks.length === 0) {
				throw new Error("Aucun netlink sélectionné");
			}

			console.log(`🚀 Processing ${selectedNetlinks.length} netlinks`);

			const BATCH_SIZE = 5; // Process in small batches
			const results = [];

			try {
				// Process netlinks in batches for better performance
				for (let i = 0; i < selectedNetlinks.length; i += BATCH_SIZE) {
					const batch = selectedNetlinks.slice(i, i + BATCH_SIZE);
					console.log(
						`📦 Processing batch ${Math.floor(i / BATCH_SIZE) + 1}/${Math.ceil(
							selectedNetlinks.length / BATCH_SIZE
						)}`
					);

					// Process each netlink in the batch
					const batchPromises = batch.map((netlink) =>
						this.processNetlinkComplete(netlink)
					);
					const batchResults = await Promise.allSettled(batchPromises);

					results.push(...batchResults);

					// Small delay between batches to be nice to the server
					if (i + BATCH_SIZE < selectedNetlinks.length) {
						await this.delay(200);
					}
				}

				// Count results
				const successful = results.filter(
					(r) => r.status === "fulfilled"
				).length;
				const failed = results.filter((r) => r.status === "rejected").length;

				console.log(
					`✅ Processing complete: ${successful} success, ${failed} failed`
				);

				if (failed > 0) {
					console.error(
						"Failed operations:",
						results.filter((r) => r.status === "rejected")
					);
				}

				return { successful, failed, results };
			} catch (error) {
				console.error("❌ Batch processing failed:", error);
				throw error;
			}
		},

		// Complete process for a single netlink: edit/create → purchase → link
		async processNetlinkComplete(netlink) {
			console.log(`🔄 Processing netlink: ${netlink.url_bought}`);

			try {
				let netlinkId;
				let netlinkResponse;

				// Step 1: Edit existing netlink OR create new netlink
				if (netlink.oldNetlinkId) {
					console.log(
						`✏️ Editing existing netlink ID: ${netlink.oldNetlinkId}`
					);
					netlink.id = netlink.oldNetlinkId; // Ensure ID is set for update
					netlinkResponse = await this.editNetlink(netlink);
					netlinkId = netlink.oldNetlinkId;
				} else {
					console.log(`➕ Creating new netlink: ${netlink.url_bought}`);
					// Prepare netlink data for creation
					this.prepareNetlinkForCreation(netlink);
					netlinkResponse = await this.addNetlink();
					netlinkId = netlinkResponse.id || netlinkResponse.insertId;

					if (!netlinkId) {
						throw new Error("Failed to get netlink ID from creation response");
					}
				}
				console.log(`✅ Netlink processed: ${netlinkId}`);

				// Step 2: Create purchase
				// if (netlink.oldNetlinkId) {
				// 	console.log(`💰 Creating purchase for netlink ID: ${netlinkId}`);
				// 	const purchaseResponse = await this.createPurchase(netlink);
				// 	const purchaseId = purchaseResponse.id;

				// 	if (!purchaseId) {
				// 		throw new Error("Failed to get purchase ID from creation response");
				// 	}

				// 	// Step 3: Link netlink to purchase
				// 	console.log(
				// 		`🔗 Linking netlink ${netlinkId} to purchase ${purchaseId}`
				// 	);
				// 	await this.linkNetlinkToPurchase(
				// 		purchaseId,
				// 		netlinkId,
				// 		netlink.price
				// 	);
				// }

				console.log(`✅ Successfully processed netlink: ${netlink.url_bought}`);

				return {
					success: true,
					netlink: netlink,
					netlinkId: netlinkId,
					// purchaseId: purchaseId,
				};
			} catch (error) {
				console.error(
					`❌ Failed to process netlink ${netlink.url_bought}:`,
					error
				);
				throw new Error(
					`Failed to process ${netlink.url_bought}: ${error.message}`
				);
			}
		},
		formatPeriodDate(period_date) {
			let date;

			// Try parsing as full date first
			if (moment(period_date, "DD/MM/YYYY", true).isValid()) {
				date = moment(period_date, "DD/MM/YYYY");
			}
			// Fallback to MM/YYYY
			else if (moment(period_date, "MM/YYYY", true).isValid()) {
				date = moment(period_date, "MM/YYYY");
			}
			// Try M/YYYY format
			else if (moment(period_date, "M/YYYY", true).isValid()) {
				date = moment(period_date, "M/YYYY");
			} else {
				// Return current month/year as fallback
				const now = new Date();
				return `${(now.getMonth() + 1)
					.toString()
					.padStart(2, "0")}/${now.getFullYear()}`;
			}

			// Return formatted MM/YYYY
			console.log(`📅 Formatted period date: ${date.format("MM/YYYY")}`);
			return date.format("MM/YYYY");
		},

		parsePrice(price) {
			console.log(`[parsePrice] Input: "${price}" (type: ${typeof price})`);

			if (!price && price !== 0) {
				console.log(`[parsePrice] Empty/null price, returning 0.00`);
				return "0.00";
			}

			// If it's already a number, just format it
			if (typeof price === "number") {
				const result = price.toFixed(2);
				console.log(`[parsePrice] Number input ${price} -> ${result}`);
				return result;
			}

			// Convert to string and clean
			let priceStr = price.toString().trim();
			console.log(`[parsePrice] After toString: "${priceStr}"`);

			// Remove any currency symbols and spaces
			const beforeClean = priceStr;
			priceStr = priceStr.replace(/[€$£¥]/g, "").replace(/\s/g, "");
			console.log(
				`[parsePrice] After removing symbols/spaces: "${beforeClean}" -> "${priceStr}"`
			);

			// Check if this is already a valid decimal number (like "844.00" from Excel)
			// This happens when xlsx formats numbers with raw:false
			const decimalTest = /^\d+(\.\d{1,2})?$/;
			console.log(
				`[parsePrice] Testing if valid decimal format: ${decimalTest.test(
					priceStr
				)}`
			);

			if (decimalTest.test(priceStr)) {
				// It's already in correct format (e.g., "844.00" or "1122.50")
				const parsed = parseFloat(priceStr);
				const result = parsed.toFixed(2);
				console.log(
					`[parsePrice] Valid decimal format: "${priceStr}" -> parsed: ${parsed} -> result: ${result}`
				);
				return result;
			}

			console.log(
				`[parsePrice] Not standard decimal, checking number format...`
			);

			// Determine format based on what separators are present
			const hasComma = priceStr.includes(",");
			const hasDot = priceStr.includes(".");

			if (hasComma && hasDot) {
				// Both comma and dot present - need to determine which is decimal
				const lastComma = priceStr.lastIndexOf(",");
				const lastDot = priceStr.lastIndexOf(".");

				if (lastDot > lastComma) {
					// US/UK format: 1,234.56 (comma is thousands, dot is decimal)
					console.log(`[parsePrice] US/UK format detected (comma before dot)`);
					priceStr = priceStr.replace(/,/g, ""); // Remove thousand separators
				} else {
					// French format: 1.234,56 (dot is thousands, comma is decimal)
					console.log(`[parsePrice] French format detected (dot before comma)`);
					priceStr = priceStr.replace(/\./g, "").replace(",", ".");
				}
			} else if (hasComma && !hasDot) {
				// Only comma - could be decimal or thousands
				const parts = priceStr.split(",");
				if (parts.length === 2 && parts[1].length === 2) {
					// Likely decimal: 1234,56
					console.log(`[parsePrice] Comma as decimal separator`);
					priceStr = priceStr.replace(",", ".");
				} else if (parts.length === 2 && parts[1].length === 3) {
					// Likely thousands: 1,234
					console.log(`[parsePrice] Comma as thousands separator`);
					priceStr = priceStr.replace(/,/g, "");
				} else {
					// Multiple commas or unclear - assume thousands
					console.log(`[parsePrice] Multiple commas, treating as thousands`);
					priceStr = priceStr.replace(/,/g, "");
				}
			} else if (hasDot && !hasComma) {
				// Only dot - in most cases this is decimal separator
				console.log(`[parsePrice] Only dot present, keeping as decimal`);
				// priceStr stays as is
			}

			console.log(`[parsePrice] After format detection: "${priceStr}"`);

			// Parse the cleaned number
			const parsed = parseFloat(priceStr);
			console.log(`[parsePrice] Final parseFloat("${priceStr}") = ${parsed}`);

			// Check if parsing was successful
			if (isNaN(parsed)) {
				console.warn(
					`[parsePrice] Could not parse price: "${price}", defaulting to 0`
				);
				return "0.00";
			}

			const result = parsed.toFixed(2);
			console.log(`[parsePrice] FINAL RESULT: ${result}`);
			return result;
		},

		formatPeriodDateV2(period_date) {
			if (!period_date) {
				const now = new Date();
				return `${(now.getMonth() + 1)
					.toString()
					.padStart(2, "0")}/${now.getFullYear()}`;
			}

			// Check if it's an Excel date number (e.g., 45839)
			if (
				typeof period_date === "number" &&
				period_date > 25000 &&
				period_date < 60000
			) {
				const excelEpoch = new Date(1899, 11, 30); // December 30, 1899
				const msPerDay = 24 * 60 * 60 * 1000;
				const jsDate = new Date(excelEpoch.getTime() + period_date * msPerDay);
				const formatted = `${(jsDate.getMonth() + 1)
					.toString()
					.padStart(2, "0")}/${jsDate.getFullYear()}`;
				console.log(`📅 Converted Excel date ${period_date} to ${formatted}`);
				return formatted;
			}

			// Check if it's already a Date object
			if (period_date instanceof Date) {
				const formatted = `${(period_date.getMonth() + 1)
					.toString()
					.padStart(2, "0")}/${period_date.getFullYear()}`;
				return formatted;
			}

			// If it's a string, try different formats
			let date;
			if (moment(period_date, "DD/MM/YYYY", true).isValid()) {
				date = moment(period_date, "DD/MM/YYYY");
			} else if (moment(period_date, "MM/YYYY", true).isValid()) {
				date = moment(period_date, "MM/YYYY");
			} else if (moment(period_date, "M/YYYY", true).isValid()) {
				date = moment(period_date, "M/YYYY");
			}

			if (date) {
				return date.format("MM/YYYY");
			}

			// Fallback
			const now = new Date();
			return `${(now.getMonth() + 1)
				.toString()
				.padStart(2, "0")}/${now.getFullYear()}`;
		},

		// Prepare netlink data for the addNetlink method
		prepareNetlinkForCreation(netlink) {
			// Set the newNetlink data that your addNetlink method expects
			this.newNetlink = {
				url_bought: netlink.url_bought,
				landing_page: netlink.landing_page,
				anchor_type: netlink.anchor_type,
				anchor: netlink.anchor,
				status: netlink.status,
				link_type: netlink.link_type,
				price: parseFloat(netlink.price).toFixed(2),
				contract_id: parseInt(netlink.contract_id) || null,
				mission_id: parseInt(netlink.mission_id) || null,
				provider_id: netlink.provider_id,
				renew_duration: netlink.renew_duration || 0,
				is_international: netlink.is_international || 0,
				period_date: this.formatPeriodDate(netlink.period_date),
				is_billable: netlink.is_billable,
				sell_price: parseFloat(netlink.sell_price || 0).toFixed(2),
				// Additional fields that might be needed
				society_id: this.getSocietyIdFromContract(netlink.contract_id),
				creation_date: new Date().toISOString().substring(0, 10) + " 02:00:00",
				dns_id: null,
				purchase_id: null, // Will be linked later
				// Default metric values
				domain_authority: null,
				page_authority: null,
				trust_flow: null,
				citation_flow: null,
				external_links: null,
				ref_domains: null,
				renew_date: this.calculateRenewDate(netlink.renew_duration),
				user_id:
					this.allMissions.find((m) => m.id === netlink.mission_id)
						.missions_users[0].id || this.activeUser.id,
			};
			console.log(`📦 Prepared netlink for creation:`, this.newNetlink);
		},

		// Your existing addNetlink method - keep as is, but ensure it uses this.newNetlink
		async addNetlink() {
			try {
				console.log(`➕ Adding new netlink:`, this.newNetlink);
				const response = await Netlink.createNetlink(this.newNetlink);
				console.log(`✅ Netlink added successfully:`, response);
				return response;
			} catch (error) {
				console.error("Error adding netlink:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de l'ajout du netlink",
					color: "danger",
				});
				throw error;
			}
		},

		// Your existing editNetlink method - fixed to avoid duplicate definition
		async editNetlink(netlink) {
			return new Promise((resolve, reject) => {
				const netlinkId = netlink.oldNetlinkId;

				if (!netlinkId) {
					reject(new Error("No oldNetlinkId found for update"));
					return;
				}

				console.log(`🔄 Updating netlink ID: ${netlinkId}`);

				// Set the ID for the update
				netlink.id = netlinkId;

				Netlink.updateNetlink(netlinkId, netlink)
					.then((response) => {
						if (response) {
							console.log(`✅ Netlink ${netlinkId} updated successfully`);
							resolve(response);
						} else {
							const errorMsg = `Failed to update netlink ${netlinkId}`;
							console.error(errorMsg);
							reject(new Error(errorMsg));
						}
					})
					.catch((error) => {
						console.error(
							`❌ Network error updating netlink ${netlinkId}:`,
							error
						);
						reject(error);
					});
			});
		},

		// Your existing createPurchase method - keep as is
		// async createPurchase(netlink) {
		// 	try {
		// 		const society = this.contractsSocietiesWithName.find(
		// 			(c) => c.contract_id == netlink.contract_id
		// 		);
		// 		let period = `${netlink.period_date
		// 			.split("/")
		// 			.reverse()
		// 			.join("-")}-01 02:00:00`;

		// 		const purchaseData = {
		// 			price: parseFloat(netlink.price).toFixed(2),
		// 			sell_price: parseFloat(netlink.sell_price || 0).toFixed(2),
		// 			contract_id: netlink.contract_id,
		// 			mission_id: netlink.mission_id,
		// 			provider_id: netlink.provider_id,
		// 			commentary: netlink.commentary || null,
		// 			is_billable: netlink.is_billable - 1, // Convert from 1/2 to 0/1
		// 			period_date: period,
		// 			user_id: this.activeUser.id,
		// 			users_id: netlink.provider_id,
		// 			// Additional required fields for purchase
		// 			contract_society_id: society ? society.society_id : null,
		// 			service_id: 10, // Assuming service_id is fixed for netlinks
		// 			is_delivered: 0,
		// 			bought_at: new Date().toISOString().substring(0, 10) + " 02:00:00",
		// 			invoice_date: null,
		// 			recurrence: netlink.renew_duration || 0,
		// 			recurrence_active: netlink.renew_duration > 0 ? 1 : 0,
		// 			// Optional fields
		// 			margin_price: 0,
		// 			margin_rate: 0,
		// 		};
		// 		const response = await Purchase.create(purchaseData);
		// 		return response;
		// 	} catch (error) {
		// 		console.error("Error creating purchase:", error);
		// 		this.$vs.notify({
		// 			title: "Erreur",
		// 			text: "Erreur lors de la création de l'achat",
		// 			color: "danger",
		// 		});
		// 		throw error;
		// 	}
		// },

		// Your existing linkNetlinkToPurchase method - keep as is
		// linkNetlinkToPurchase(purchase_id, netlink_id, price) {
		// 	return new Promise((resolve, reject) => {
		// 		console.log(
		// 			`🔗 Linking netlink ${netlink_id} to purchase ${purchase_id} with price ${price}`
		// 		);
		// 		let body = {
		// 			purchase_id: purchase_id,
		// 			netlink_id: netlink_id,
		// 			price: parseFloat(price).toFixed(2),
		// 		};
		// 		Netlink.linkNetlinkToPurchase(body)
		// 			.then((response) => {
		// 				if (response) {
		// 					console.log(
		// 						`✅ Netlink ${netlink_id} linked to purchase ${purchase_id} successfully`
		// 					);
		// 					resolve(response);
		// 				} else {
		// 					const errorMsg = `Failed to link netlink ${netlink_id} to purchase ${purchase_id}`;
		// 					reject(new Error(errorMsg));
		// 				}
		// 			})
		// 			.catch((error) => {
		// 				console.error(
		// 					`❌ Network error linking netlink ${netlink_id} to purchase ${purchase_id}:`,
		// 					error
		// 				);
		// 				reject(error);
		// 			});
		// 	});
		// },

		// Helper methods
		getSocietyIdFromContract(contractId) {
			const contract = this.contractsSocietiesWithName.find(
				(c) => c.contract_id == contractId
			);
			return contract ? contract.society_id : null;
		},

		calculateRenewDate(renewDuration) {
			if (!renewDuration || renewDuration === 0) {
				return null; // No renewal
			}

			const now = new Date();

			if (renewDuration === 1) {
				// Monthly renewal
				now.setMonth(now.getMonth() + 1);
			} else if (renewDuration === 12) {
				// Annual renewal
				now.setFullYear(now.getFullYear() + 1);
			}

			return now.toISOString().substring(0, 10) + " 02:00:00";
		},

		// Utility: Add delay between batches
		delay(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		// Enhanced acceptPurchases with proper error handling
		async acceptPurchases() {
			this.loading = true;

			try {
				console.log("🚀 Starting netlink submission...");

				const results = await this.submitPurchasesToServer();

				this.showValidationPopup = false;

				if (results.failed === 0) {
					this.$vs.notify({
						title: "Succès",
						text: `${results.successful} netlinks traités avec succès!`,
						color: "success",
					});
				} else {
					this.$vs.notify({
						title: "Partiellement réussi",
						text: `${results.successful} netlinks réussis, ${results.failed} échecs`,
						color: "warning",
					});
				}

				// Remove successfully processed netlinks from the list
				this.removeSuccessfulNetlinks(results);

				// Refresh store data
				await this.$store.dispatch("getAllNetlink");
				await this.$store.dispatch("getAllPurchasesWithRecurring");
			} catch (error) {
				console.error("Submission failed:", error);
				this.$vs.notify({
					title: "Erreur",
					text: `Erreur lors de l'import: ${error.message}`,
					color: "danger",
				});
			} finally {
				this.loading = false;
			}
		},

		// Remove successfully processed netlinks from the UI list
		removeSuccessfulNetlinks(results) {
			const processedNetlinks = results.results
				.filter((r) => r.status === "fulfilled")
				.map((r) => r.value.netlink);

			this.netlinkList = this.netlinkList.filter(
				(nl) => !processedNetlinks.includes(nl)
			);

			console.log(
				`🧹 Removed ${processedNetlinks.length} processed netlinks from UI`
			);
		},

		async acceptProviders() {
			const validProviders = this.newProviderList.filter(
				(p) => p.selected && p.isValid
			);

			if (validProviders.length === 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Aucun prestataire valide sélectionné",
				});
				return;
			}

			try {
				const res = await this.$http.post(
					this.$store.state.backendApiUrl + "providers/addMultiple",
					{
						providers: validProviders,
						service_id: 10,
					}
				);

				// Add new providers to local list
				this.netlinkProviders = this.netlinkProviders.concat(res.data[0]);

				this.showNewProviderPopup = false;
				this.newProviderList = [];

				this.$vs.notify({ title: "Succès", text: "Prestataires ajoutés" });
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de l'ajout des prestataires",
				});
			}
		},

		declineProviders() {
			this.showNewProviderPopup = false;
			this.newProviderList = [];
		},

		downloadTemplate() {
			// window.open(
			// 	"https://docs.google.com/spreadsheets/d/1b-wFZMmcQH2RUN-VbCE1GTCUIS1-5cFIGdXjaivwNB4/edit?gid=74333603#gid=74333603",
			// 	"_blank"
			// );
			// window.open(
			// 	"https://docs.google.com/spreadsheets/d/1lq-_Y5ikt8YU_o-ZkXuoqf7BhD5raPizbrFWJ6LeC3g/edit?gid=74333603#gid=74333603",
			// 	"_blank"
			// );
			window.open(
				"https://docs.google.com/spreadsheets/d/1eZwNIC9NpnArudJxpx47uZwTqU3gD-cM3CGByofxkG8/edit?gid=74333603#gid=74333603",
				"_blank"
			);
		},
	},
};
</script>

<style lang="scss">
.vs-tooltip {
	white-space: pre-line;
}

#new-provider > .vs-popup {
	width: auto;
}

/* Loading overlay styles */
.loading-overlay {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 200px;
	background-color: rgba(255, 255, 255, 0.95);
	border-radius: 8px;

	.loading-content {
		text-align: center;
		padding: 20px;

		.loading-text {
			margin-top: 15px;
			font-size: 16px;
			font-weight: 500;
			color: #333;
		}

		.loading-subtext {
			margin-top: 5px;
			font-size: 12px;
			color: #666;
			font-style: italic;
		}
	}
}

.form-select {
	width: 100%;
	padding: 8px 12px;
	border: 1px solid #ddd;
	border-radius: 4px;
	background-color: white;
	font-size: 14px;
}

.form-select:focus {
	outline: none;
	border-color: #007bff;
	box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-select[multiple] {
	height: auto;
	min-height: 80px;
}

/* Enhanced tooltip styling */
.vs-tooltip .vs-tooltip--text {
	white-space: pre-line;
	max-width: 300px;
	text-align: left;
	font-size: 12px;
	line-height: 1.4;
}

.vs-tooltip {
	white-space: pre-line;
}

#new-provider > .vs-popup {
	width: auto;
}

.form-select {
	width: 100%;
	padding: 8px 12px;
	border: 1px solid #ddd;
	border-radius: 4px;
	background-color: white;
	font-size: 14px;
}

.form-select:focus {
	outline: none;
	border-color: #007bff;
	box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-select[multiple] {
	height: auto;
	min-height: 80px;
}

/* Validation icon styling */
.validation-icon-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 40px;
}

.validation-icon {
	cursor: pointer;
	transition: all 0.3s ease;
}

.validation-icon:hover {
	transform: scale(1.2);
}

/* Custom Tooltip Styles - Simplified */
.custom-tooltip {
	position: fixed;
	background-color: rgba(44, 62, 80, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 8px;
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
	z-index: 9999;
	opacity: 0;
	animation: tooltipFadeIn 0.2s ease-out forwards;
	max-width: 350px;
	min-width: 200px;
}

.custom-tooltip-content {
	padding: 12px 16px;
	color: white;
	font-size: 12px;
	line-height: 1.5;
	font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
	text-align: left;
	word-wrap: break-word;
}

.custom-tooltip-arrow {
	position: absolute;
	width: 0;
	height: 0;
	border-style: solid;
}

.tooltip-top .custom-tooltip-arrow {
	bottom: -6px;
	left: 100%;
	transform: translateX(-100%);
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid rgba(44, 62, 80, 0.95);
}

.tooltip-bottom .custom-tooltip-arrow {
	top: -6px;
	left: 100%;
	transform: translateX(-100%);
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-bottom: 6px solid rgba(44, 62, 80, 0.95);
}

/* Enhanced animations */
@keyframes tooltipFadeIn {
	from {
		opacity: 0;
		transform: translateY(-5px) scale(0.95);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}
</style>